
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useStore } from 'vuex';

  export default defineComponent({
    name: 'areas-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<{ governorateId: string | number | '' }>({
        governorateId: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        emit('type-selected', selectedItems.value);
      };

      const onReset = () => {
        selectedItems.value = { governorateId: '' };
        emit('reset', selectedItems.value);
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_GOV_LIST);
      });

      return {
        govs: computed(() => store.getters.allListGov || []),
        selectedItems,
        translate,
        onSubmit,
        onReset,
      };
    },
  });
